<template>
    <Panel header="Dados Pessoais" :toggleable="true" class="p-mb-4">
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-3">
                <label>Tipo de Documento <span class="p-error">*</span></label>
                <Dropdown v-model="cliente.tipoDocumento" :options="tiposDocumento" optionLabel="label" 
                optionValue="value" :class="{'p-invalid': enviado && !cliente.tipoDocumento}" :disabled="modo === 'edicao' ? true : false"/>
                <small v-if="enviado && !cliente.tipoDocumento" class="p-error">Campo obrigatório.</small>
            </div>
            <div class="p-field p-col-12 p-md-3">
                <label>Documento <span class="p-error">*</span></label>
                <InputMask v-if="cliente.tipoDocumento === 'cnpj'" 
                v-model="cliente.documento" mask="99.999.999/9999-99" :class="{'p-invalid': enviado && !cliente.documento}" 
                :disabled="modo === 'edicao' ? true : false"/>
                <InputMask v-else v-model="cliente.documento" mask="999.999.999-99" :class="{'p-invalid': enviado && !cliente.documento}" 
                :disabled="modo === 'edicao' ? true : false"/>
                <small v-if="enviado && !cliente.documento" class="p-error">Campo obrigatório.</small>
            </div>
            <div class="p-field p-col-12 p-md-6">
                <label>{{ cliente.tipoDocumento === 'cnpj' ? 'Razão Social' : 'Nome' }} <span class="p-error">*</span></label>
                <InputText v-model="cliente.razaoSocial" :class="{'p-invalid': enviado && !cliente.razaoSocial}" />
                <small v-if="enviado && !cliente.razaoSocial" class="p-error">Campo obrigatório.</small>
            </div>
            <div class="p-field p-col-12 p-md-4">
                <label>E-mail <span class="p-error">*</span></label>
                <InputText v-model="cliente.email" :class="{'p-invalid': enviado && !cliente.email}" :disabled="modo === 'edicao' ? true : false"/>
                <small v-if="enviado && !cliente.email" class="p-error">Campo obrigatório.</small>
            </div>
            <div class="p-field p-col-12 p-md-4">
                <label>Telefone <span class="p-error">*</span></label>
                <InputMask v-model="cliente.telefone" mask="(99) 9999-9999" :class="{'p-invalid': enviado && !cliente.telefone}" />
                <small v-if="enviado && !cliente.telefone" class="p-error">Campo obrigatório.</small>
            </div>
            <div class="p-field p-col-12 p-md-4">
                <label>Celular <span class="p-error">*</span></label>
                <InputMask v-model="cliente.celular" mask="(99) 9 9999-9999" :class="{'p-invalid': enviado && !cliente.celular}" />
                <small v-if="enviado && !cliente.celular" class="p-error">Campo obrigatório.</small>
            </div>
            <div class="p-field p-col-12 p-md-6">
                <label>Segmento <span class="p-error">*</span></label>
                <InputText v-model="cliente.segmento" :class="{'p-invalid': enviado && !cliente.segmento}" />
                <small v-if="enviado && !cliente.segmento" class="p-error">Campo obrigatório.</small>
            </div>
        </div>
        <div v-if="modo === 'edicao'" class="p-d-flex p-jc-end p-mt-3">
            <Button label="Salvar" icon="pi pi-save" @click="salvar" :loading="enviando" />
        </div>
    </Panel>
</template>

<script>
import ClienteIKAcessoService from '@/service/ClienteIKAcessoService';
import { exibirMensagem } from '@/global';

export default {
    props: {
        modo: { type: String, default: 'novo' },
        clienteId: { type: [String, Number], default: null },
        initialData: { type: Object, default: null }
    },
    data() {
        return {
            enviado: false,
            enviando: false,
            tiposDocumento: [
                { label: 'CPF', value: 'cpf' },
                { label: 'CNPJ', value: 'cnpj' }
            ],
            cliente: {
                tipoDocumento: 'cnpj',
                documento: null,
                razaoSocial: null,
                email: null,
                telefone: null,
                celular: null,
                segmento: null
            }
        };
    },
    watch: {
        initialData(newVal) {
            if (newVal) {
                this.cliente = { ...this.cliente, ...newVal };
                delete this.cliente.endereco;
            }
        }
    },
    methods: {
        validar() {
            this.enviado = true;
            return [
                this.cliente.tipoDocumento,
                this.cliente.documento,
                this.cliente.razaoSocial,
                this.cliente.email,
                this.cliente.telefone,
                this.cliente.celular,
                this.cliente.segmento
            ].every(v => v != null && v !== '');
        },
        getData() {
            const apenasDigitos = v => v ? v.replace(/\D/g, '') : v;
            return {
                ...this.cliente,
                documento: apenasDigitos(this.cliente.documento),
                telefone: apenasDigitos(this.cliente.telefone),
                celular: apenasDigitos(this.cliente.celular)
            };
        },
        salvar() {
            if (!this.validar()) {
                this.$toast.add({ severity: 'warn', summary: 'Atenção', detail: 'Preencha todos os campos obrigatórios.', life: 3000 });
                return;
            }
            this.enviando = true;
            this.clienteService.alterarDadosCliente(this.clienteId, this.getData())
                .then(() => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Dados atualizados com sucesso.', life: 3000 });
                })
                .catch(erro => { exibirMensagem(this, erro); })
                .finally(() => { this.enviando = false; });
        }
    },
    created() {
        this.clienteService = new ClienteIKAcessoService();
    },
    mounted() {
        if (this.initialData) {
            this.cliente = { ...this.cliente, ...this.initialData };
            delete this.cliente.endereco;
        }
    }
};
</script>
